import product1 from "./images/canned.png";
import product2 from "./images/beverages.jpg";
import product3 from "./images/care.jpg";
import product4 from "./images/other.jpg";
import product5 from "./images/other1.jpg";
import product6 from "./images/canned1.jpg";
import product7 from "./images/canned2.jpg";
import product8 from "./images/canned3.jpg";
import product9 from "./images/canned4.jpg";
import product10 from "./images/beverages1.jpg";
import product11 from "./images/beverages2.jpg";
import product12 from "./images/beverages3.jpg";
import product13 from "./images/beverages4.jpg";
import product14 from "./images/care1.jpg";
import product15 from "./images/care2.jpg";
import product16 from "./images/care3.jpg";
import product17 from "./images/care4.jpg";
import product18 from "./images/frozen1.jpg";
import product19 from "./images/frozen2.jpg";
import product20 from "./images/frozen3.jpg";
import product21 from "./images/frozen4.jpg";
import product22 from "./images/frozen5.jpg";
import product23 from "./images/condiments1.jpg";
import product24 from "./images/condiments2.jpg";
import product25 from "./images/condiments3.jpg";
import product26 from "./images/snacks1.jpg";
import product27 from "./images/snacks2.jpg";
import product28 from "./images/snacks3.jpg";
import product29 from "./images/snacks4.jpg";
import product30 from "./images/snacks5.jpg";
import product31 from "./images/snacks6.jpg";

export const PRODUCTS = [
  {
    id: 1,
    productName: "Argentina Meat Loaf",
    price: 46.0,
    category: "Canned Goods",
    productImage: product1,
  },
  {
    id: 2,
    productName: "Nestea",
    price: 12.0,
    category: "Beverages",
    productImage: product2,
  },
  {
    id: 3,
    productName: "Safeguard White",
    price: 122.0,
    category: "Personal Care",
    productImage: product3,
  },
  {
    id: 4,
    productName: "Crayola 16 Crayons",
    price: 35.0,
    category: "Other",
    productImage: product4,
  },
  {
    id: 5,
    productName: "Mongol 2 Pencil",
    price: 19.99,
    category: "Other",
    productImage: product5,
  },
  {
    id: 6,
    productName: "555 Tuna Flakes in Oil",
    price: 32.99,
    category: "Canned Goods",
    productImage: product6,
  },

  {
    id: 7,
    productName: "Pure Foods Corned Beef",
    price: 65.25,
    category: "Canned Goods",
    productImage: product7,
  },

  {
    id: 8,
    productName: "Ligo Sardines In Tomato Sauce",
    price: 31.35,
    category: "Canned Goods",
    productImage: product8,
  },

  {
    id: 9,
    productName: "Maling Luncheon Meat",
    price: 63.99,
    category: "Canned Goods",
    productImage: product9,
  },

  {
    id: 10,
    productName: "Tang Orange",
    price: 11.99,
    category: "Beverages",
    productImage: product10,
  },

  {
    id: 11,
    productName: "Nescafe 3 in 1",
    price: 29.99,
    category: "Beverages",
    productImage: product11,
  },

  {
    id: 12,
    productName: "Milo",
    price: 35.99,
    category: "Beverages",
    productImage: product12,
  },

  {
    id: 13,
    productName: "San Mig Light Beer",
    price: 49.99,
    category: "Beverages",
    productImage: product13,
  },

  {
    id: 14,
    productName: "Clear Shampoo",
    price: 75.60,
    category: "Personal Care",
    productImage: product14,
  },

  {
    id: 15,
    productName: "Dove Pink",
    price: 95.85,
    category: "Personal Care",
    productImage: product15,
  },

  {
    id: 16,
    productName: "Rexona Original",
    price: 120.25,
    category: "Personal Care",
    productImage: product16,
  },

  {
    id: 17,
    productName: "Colgate",
    price: 69.99,
    category: "Personal Care",
    productImage: product17,
  },

  {
    id: 18,
    productName: "Pure Foods Chicken Nuggets",
    price: 105.99,
    category: "Frozen",
    productImage: product18,
  },

  {
    id: 19,
    productName: "Magnolia Whole Chicken",
    price: 225.65,
    category: "Frozen",
    productImage: product19,
  },

  {
    id: 20,
    productName: "Tender Juicy Hotdog",
    price: 185.99,
    category: "Frozen",
    productImage: product20,
  },

  {
    id: 21,
    productName: "Pure Foods Fiesta Ham",
    price: 165.75,
    category: "Frozen",
    productImage: product21,
  },

  {
    id: 22,
    productName: "Pure Foods Chicken Ham",
    price: 165.99,
    category: "Frozen",
    productImage: product22,
  },

  {
    id: 23,
    productName: "Datu Puti Vinegar",
    price: 85.99,
    category: "Condiments",
    productImage: product23,
  },

  {
    id: 24,
    productName: "UFC Ketchup",
    price: 65.99,
    category: "Condiments",
    productImage: product24,
  },

  {
    id: 25,
    productName: "Datu Puti Toyo",
    price: 81.99,
    category: "Condiments",
    productImage: product25,
  },

  {
    id: 26,
    productName: "Piattos Cheese",
    price: 15.25,
    category: "Snacks",
    productImage: product26,
  },

  {
    id: 27,
    productName: "V cut Spicy Barbecue Flavor",
    price: 22.35,
    category: "Snacks",
    productImage: product27,
  },

  {
    id: 28,
    productName: "Nagaraya Hot & Spicy",
    price: 13.99,
    category: "Snacks",
    productImage: product28,
  },

  {
    id: 29,
    productName: "Hansel Crackers",
    price: 35.99,
    category: "Snacks",
    productImage: product29,
  },

  {
    id: 30,
    productName: "Oreo",
    price: 45.99,
    category: "Snacks",
    productImage: product30,
  },

  {
    id: 31,
    productName: "Fudgebar",
    price: 34.25,
    category: "Snacks",
    productImage: product31,
  },
  
];